import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-item" }
const _hoisted_4 = { class: "filter-item" }
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  class: "color-danger",
  title: "投诉次数"
}
const _hoisted_7 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "color-success ml5",
  title: "自动分配订单"
}
const _hoisted_10 = {
  key: 2,
  class: "color-success ml5",
  title: "该品牌订单为客服发货（牧龙食品、爱立颂、红跑车、格丽思蛋糕卡、初选实体卡、美心提货券）"
}
const _hoisted_11 = { class: "action-list" }
const _hoisted_12 = {
  class: "bold ml5",
  style: {"margin-top":"-2px"}
}
const _hoisted_13 = {
  class: "bold ml5",
  style: {"margin-top":"-2px"}
}
const _hoisted_14 = {
  class: "bold ml5",
  style: {"margin-top":"-2px"}
}

import { getCurrentInstance, reactive, ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Pagination from '@/components/Pagination.vue'
import { getAllOrderListApi, getAllHistoryOrderListApi } from '@/apis/order'
import { OrderStatus, OrderType } from '@/enums/order'
import SelectBrand from '@/components/SelectBrand.vue'
import { ElLoading } from 'element-plus'
import Keys from '@/constant/key'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils'
import { openRouteInNewWindow } from '@/utils/router-helper'
import dayjs from 'dayjs'
import { downloadFile } from '@/utils/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const route = useRoute()
const router = useRouter()
const store = useStore()
const userGroups = store.state.user.userInfo.group_id.split(',')
// 监听路由变化，重新获取数据
watch(() => route.path, () => {
    filters.is_allot = route.path.includes('service-list') ? '1' : ''
    onSearch()
})

const filters = reactive({
    name:               '',     // 用户名
    order_no:           '',     // 订单号
    phone:              '',     // 收货人手机
    buyer_phone:        '',     // 下单人手机
    out_order_no:       '',     // 第三方订单号
    express_no:         '',     // 物流单号
    brand_id:           '',     // 品牌
    pay_status:         '',     // 支付状态
    status:             '',     // 订单状态
    order_type:         '',     // 商品类型
    is_hidden:          '',     // 显示类型
    created_at_start:   dayjs().subtract(30, 'day').format('YYYY-MM-DD'),     // 开始下单日期
    created_at_end:     dayjs().format('YYYY-MM-DD'),     // 结束下单日期
    ship_date:          '',     // 配送日期
    is_allot:           '',     // 0-默认，1-需客服处理订单，2-商户自主接单，3-系统对接
    page_size:          10,     // 每页显示条数
    page:               1,      // 当前页码
    is_urge_status:          false,  // 是否催单数据
})

// 专题列表
const serviceCount = ref(0) // 仅退款列表
const refundCount = ref(0) // 退货退款列表
const delayCount = ref(0) // 延迟列表
const tableData = ref([])
const total = ref(0)
let loadingIns:any = null

// 日期禁用函数
const disabledStartDate = (time: Date) => {
    // 未选中历史订单：开始时间不能早于 2025-06-01
    if (!filters.is_history) {
        const limitDate = dayjs('2025-06-01')
        return time.getTime() < limitDate.valueOf()
    } else {
        // 选中历史订单：开始和结束时间必须在 2026-06-01 之前
        const limitDate = dayjs('2026-06-01')
        return time.getTime() >= limitDate.valueOf()
    }
}

const disabledEndDate = (time: Date) => {
    // 未选中历史订单：结束时间不限制
    // 选中历史订单：结束时间必须在 2026-06-01 之前
    if (filters.is_history) {
        const limitDate = dayjs('2026-06-01')
        return time.getTime() >= limitDate.valueOf()
    }
    return false
}

// 监听历史订单状态变化
watch(() => filters.is_history, (isHistory) => {
    if (isHistory) {
        filters.created_at_start = '2025-05-01'
        filters.created_at_end = '2025-05-31'
    } else {
        filters.created_at_start = dayjs().subtract(30, 'day').format('YYYY-MM-DD')
        filters.created_at_end = dayjs().format('YYYY-MM-DD')
    }
    onSearch()
})
// 监听催单订单状态变化
watch(() => filters.is_urge_status, (isRemind) => {
    onSearch()
})

const getList = async (isAuto = false) => {
    if (!isAuto) {
        loadingIns = ElLoading.service({
            target: '.table-container',
            text: '加载数据...',
            background: 'rgba(255, 255, 255, .7)'
        })
    }
    const api = filters.is_history ? getAllHistoryOrderListApi : getAllOrderListApi
    const { code, data, msg } = await api({ ...filters, admin_type: 1, notShowLoading: true, is_urge: filters.is_urge_status ? 1 : 0 }) as any
    if (loadingIns) loadingIns.close()
    if (code != 0) {
        tableData.value = []
        total.value = 0
        if (!isAuto) {
            return proxy.$message({ type: 'error', message: msg })
        }
        return
    }
    tableData.value = data.data
    total.value = data.total
    serviceCount.value = data.service
    refundCount.value = data.refund_nums
    delayCount.value = data.yanchi_nums
}

// 自动刷新定时器提示
let refreshTimer: any = null
const startRefresh = () => {
    stopRefresh()
    refreshTimer = setInterval(() => {
        getList(true)
    }, 15000)
}
const stopRefresh = () => {
    if (refreshTimer) {
        clearInterval(refreshTimer)
        refreshTimer = null
    }
}

// 监听跨标签页的消息通知
const orderChannel = new BroadcastChannel('order-channel')
orderChannel.onmessage = (event) => {
    if (event.data && event.data.type === 'REFRESH_LIST') {
        getList(true)
    }
}

onMounted(() => {
    getList()
    startRefresh()
})

onUnmounted(() => {
    stopRefresh()
    orderChannel.close()
})

const tableRowClassName = ({row, rowIndex}) => {
    const { user, brand_id } = row
    if (user?.grade == '1000') {
        return 'color-error'
    } else if (user?.sale_channel == '疑似黄牛') {
        return 'color-warning'
    } else if (user?.sale_channel.indexOf('星空') > -1) {
        return 'color-primary'
    } else if ([102788, 102805, 103496].includes(brand_id)) {
        return 'color-error'
    } else {
        return ''
    }
}

const getTooltip = (row) => {
    const { user, brand_id } = row
    if (user?.grade == '1000') {
        return '大客户订单'
    } else if (user?.sale_channel == '疑似黄牛') {
        return '疑似黄牛订单'
    } else if (user?.sale_channel.indexOf('星空') > -1) {
        return '【星空】渠道订单'
    } else if ([102788, 102805, 103496].includes(brand_id)) {
        return '指定特殊品牌订单'
    } else {
        return ''
    }
}

// 跳转至编辑页
const toEdit = (row: any, type: string) => {
    openRouteInNewWindow({
        path: `/order/${type}?id=${row.id}`,
        query: { id: row.id }
    })
}
// 跳转至其他订单列表页
const onRedirect = (path: string) => {
    router.push(path)
}

const onExport = (type) => {
    if (type == 1) {
        downloadFile('/admin/merchant/getOrderLists', {
            ...filters,
            is_export: 1,
        })
    } else {
        downloadFile('/opsapi/out_order', { exportForCurrencyValue: 1 })
    }
}

const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.created_at_start,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.created_at_start) = $event)),
        placeholder: "开始下单日期",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.created_at_end,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.created_at_end) = $event)),
        placeholder: "结束下单日期",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "收货人姓名",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.order_no,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.order_no) = $event)),
        modelModifiers: { trim: true },
        placeholder: "订单号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.phone,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.phone) = $event)),
        modelModifiers: { trim: true },
        placeholder: "收货人手机",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.buyer_phone,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.buyer_phone) = $event)),
        modelModifiers: { trim: true },
        placeholder: "下单人手机",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.out_order_no,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.out_order_no) = $event)),
        modelModifiers: { trim: true },
        placeholder: "第三方订单号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.express_no,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.express_no) = $event)),
        modelModifiers: { trim: true },
        placeholder: "物流单号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(SelectBrand, {
        class: "filter-item",
        modelValue: filters.brand_id,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.brand_id) = $event)),
        placeholder: "品牌",
        clearable: "",
        filterable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.pay_status,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.pay_status) = $event)),
        placeholder: "支付状态",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "未支付",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "已支付",
            value: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filters.status) = $event)),
        placeholder: "订单状态",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待分配",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "已分配",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "已完成",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "已取消",
            value: 3
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.order_type,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((filters.order_type) = $event)),
        placeholder: "商品类型",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "蛋糕订单",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "面包订单",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "零食订单",
            value: 5
          }),
          _createVNode(_component_el_option, {
            label: "鲜花订单",
            value: 8
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.is_hidden,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((filters.is_hidden) = $event)),
        placeholder: "显示类型",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "正常订单",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "隐藏订单",
            value: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.ship_date,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((filters.ship_date) = $event)),
        placeholder: "配送日期",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.is_hidden,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((filters.is_hidden) = $event)),
        placeholder: "接单类型",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "客服处理订单",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "商户自主接单",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "系统对接",
            value: 3
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_checkbox, {
          modelValue: filters.is_history,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((filters.is_history) = $event))
        }, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [
            _createTextVNode("历史订单")
          ])),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_checkbox, {
          modelValue: filters.is_urge_status,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((filters.is_urge_status) = $event))
        }, {
          default: _withCtx(() => _cache[26] || (_cache[26] = [
            _createTextVNode("催单数据")
          ])),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[17] || (_cache[17] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[27] || (_cache[27] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[18] || (_cache[18] = ($event: any) => (onExport(1)))
      }, {
        default: _withCtx(() => _cache[28] || (_cache[28] = [
          _createTextVNode("导出")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[19] || (_cache[19] = ($event: any) => (onExport(2)))
      }, {
        default: _withCtx(() => _cache[29] || (_cache[29] = [
          _createTextVNode("超时订单导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: "",
      "row-class-name": tableRowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "订单号",
          width: "115"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", {
              title: getTooltip(row)
            }, _toDisplayString(row.order_no), 9, _hoisted_5),
            _createVNode(_component_el_tooltip, {
              content: getTooltip(row)
            }, null, 8, ["content"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "类型",
          width: "75"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(OrderType)[row.order_type]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, null, {
          header: _withCtx(() => _cache[30] || (_cache[30] = [
            _createElementVNode("span", null, "用户", -1),
            _createElementVNode("span", { class: "color-danger font10" }, "（投诉次数）", -1)
          ])),
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.user?.username || ''), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(`${row.complaint_number > 0 ? '（' + row.complaint_number + '）' : '' }`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "创建时间",
          width: "145"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.created_at) + " ", 1),
            (row.urge_count > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "（催单" + _toDisplayString(row.urge_count) + "次）", 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "配送时间",
          width: "170"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`${ row.ship_date && row.ship_date != '0000-00-00' ? row.ship_date : '' } ${ row.ship_time_text }`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "支付状态",
          width: "75"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.pay_status ? '已支付' : '未支付'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "paid_at",
          label: "支付时间",
          width: "145"
        }),
        _createVNode(_component_el_table_column, { label: "订单来源" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.channel_name) + " ", 1),
            (row.vip_type == 1 || row.vip_type == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _cache[31] || (_cache[31] = [
                  _createElementVNode("img", {
                    src: "https://image-oss.dangaoss.cn/homeImage/homeImage_20260303095306_29.png",
                    style: {"width":"12px","height":"12px"},
                    class: "ml5",
                    alt: "会员",
                    title: "会员用户"
                  }, null, -1),
                  _createElementVNode("img", {
                    src: "https://image-oss.dangaoss.cn/homeImage/homeImage_20260303095306_2.png",
                    style: {"width":"12px","height":"12px"},
                    class: "ml5",
                    alt: "帮订",
                    title: "帮订订单"
                  }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (row.is_allot == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(自)"))
              : _createCommentVNode("", true),
            ([103997, 103911, 102946, 103814, 103854, 103906, 103052].includes(row.brand_id))
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(客发)"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "订单状态",
          width: "75"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(OrderStatus)[row.status] == '待确认' ? '待分配' : _unref(OrderStatus)[row.status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "130"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (toEdit(row, 'show'))
              }, {
                default: _withCtx(() => _cache[32] || (_cache[32] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (!_unref(userGroups).includes('75'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (toEdit(row, 'edit'))
                  }, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                      _createTextVNode("编辑")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      total: total.value,
      currentPage: filters.page,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["total", "currentPage"]),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[20] || (_cache[20] = ($event: any) => (onExport(2)))
        }, {
          default: _withCtx(() => _cache[34] || (_cache[34] = [
            _createTextVNode("超时订单导出")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (onRedirect('/merchant-admin/fine-list')))
        }, {
          default: _withCtx(() => _cache[35] || (_cache[35] = [
            _createTextVNode("罚款订单")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (onRedirect('/order/delay-list')))
        }, {
          default: _withCtx(() => [
            _cache[36] || (_cache[36] = _createTextVNode("延迟订单")),
            _createElementVNode("span", _hoisted_12, "(" + _toDisplayString(delayCount.value) + ")", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (onRedirect('/order/after-sale-list')))
        }, {
          default: _withCtx(() => [
            _cache[37] || (_cache[37] = _createTextVNode("仅退款订单")),
            _createElementVNode("span", _hoisted_13, "(" + _toDisplayString(serviceCount.value) + ")", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[24] || (_cache[24] = ($event: any) => (onRedirect('/order/after-sale-list?type=2')))
        }, {
          default: _withCtx(() => [
            _cache[38] || (_cache[38] = _createTextVNode("退货退款订单")),
            _createElementVNode("span", _hoisted_14, "(" + _toDisplayString(refundCount.value) + ")", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})